import axios from "axios";

const api = axios.create({
  baseURL: "https://api.whisperingsand.lv/wp-json",
});

export const getNews = () => api.get("/custom/v1/news");
export const getNewsById = (id: string) => api.get(`/custom/v1/news/${id}`);

export const getDogs = () => api.get("/custom/v1/dogs");
export const getDogById = (id: string) => api.get(`/custom/v1/dogs/${id}`);

export const getLitters = () => api.get("/custom/v1/litters");
export const getLitterById = (id: string) => api.get(`/custom/v1/litter/${id}`);

export const getPuppyById = (id: string) => api.get(`/custom/v1/puppies/${id}`);

export const getAvailablePuppies = () =>
  api.get("/custom/v1/puppies/available");

export const getSettings = () => api.get("/custom/v1/settings");

export const getPedigree = (id: string) => api.get(`/custom/v1/pedigree/${id}`);
